import React from 'react'
import {Link} from 'react-router-dom'

function Adoption() {


  
  return (
    <section className="adoption-area">
    <div className="container">
 
    </div>
  </section>
  )
}

export default Adoption;
